<app-quote-container>
    <ng-template>
        <div class="error-page">
            <div class="error-icon">
            </div>
            <p class="heading">Error<br /></p>
            <div>
                <p>There has been an application error.</p>
            </div>
        </div>
    </ng-template>
</app-quote-container>